import { DateTime, } from 'luxon';
export function ensureDateTime(dateTime) {
    if (dateTime.isValid) {
        return dateTime;
    }
    throw new Error(`Invalid DateTime: ${dateTime.invalidReason}: ${dateTime.invalidExplanation}`);
}
export function fromIsoDate(isoDate) {
    const dateTime = DateTime.fromFormat(isoDate, 'yyyy-MM-dd', {
        zone: 'utc',
    });
    return ensureDateTime(dateTime);
}
export function toDateTime(date) {
    let dateTime;
    if (date instanceof DateTime) {
        dateTime = date;
    }
    else if (typeof date === 'string') {
        dateTime = DateTime.fromISO(date);
    }
    else {
        dateTime = DateTime.fromJSDate(date);
    }
    return ensureDateTime(dateTime);
}
export function formatWeekRange(start, end, locale) {
    const dayMonth = {
        day: '2-digit',
        month: 'long',
    };
    const dayMonthYear = {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    };
    return start.year === end.year
        ? `${start.toLocaleString(dayMonth, { locale })} - ${end.toLocaleString(dayMonthYear, { locale })}`
        : `${start.toLocaleString(dayMonthYear, { locale })} - ${end.toLocaleString(dayMonthYear, { locale })}`;
}
//# sourceMappingURL=TimeUtils.js.map